export default {
    props: getProps(),
}

function getProps(){
    return {
        submitting: Boolean,
        submittingText: String,
        loadingText: String
    }
}
